// ** React Imports
import { Fragment, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// ** Layouts
import LayoutWrapper from '../../core/layouts/components/layout-wrapper/LayoutWrapper';

const getRouteMeta = (route) => {
  if (Object.keys(route.element.props).length === 0) {
    if (route.meta) {
      return { routeMeta: route.meta };
    }
  }
  return {};
};

const verifyLayoutElement = (routes) => {
  return routes.map((route) => {
    let isBlank = false;
    let isChildren = false;
    // ** Checks if Route layout or Default layout matches current layout
    if (route.meta && route.meta.layout && route.children) {
      if (route.meta && route.meta.layout === 'blank') {
        isBlank = true;
      }
      if (route.meta && route.meta.layout === 'children') {
        isChildren = true;
      }
      let Wrapper = LayoutWrapper;
      if (isBlank) {
        Wrapper = Fragment;
      }
      return {
        ...route,
        children: route.children.map((child) => {
          let layoutRoute = {
            ...child,
            element: (
              <Wrapper {...(isBlank === false ? getRouteMeta(child) : {})}>
                <Suspense fallback={null}>
                  {isChildren ? child.element : <Outlet />}
                </Suspense>
              </Wrapper>
            )
          };
          return layoutRoute;
        })
      };
    }
    return route;
  });
};

export {
  verifyLayoutElement
};
